<template>
  <div class="categories-filter">
        <div v-if="!collapsed" class="checkbox-container">
            <div class="checkbox-button gap-05vw" v-for="categories of currentCategories" :key="categories.title">
                <input @change="setSelectedCategories(categories.title)" :value="categories.title" type="checkbox" v-model="selectedCategories" :checked="selectedCategories.includes(categories.title)">
                <p :class="categories.title == 'Sale' ? 'red' : ''">{{categories.title}}</p>
            </div>
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import smoothReflow from 'vue-smooth-reflow'
export default {
    mixins: [smoothReflow],
    props:{
        categoriesArray: Object,
    },
    data() {
        return{
            collapsed: false,
        }
    },
    computed: {
        selectedCategories: {
            get(){return this.$store.state.selectedCategories},
            set(value){
                gtag('event', 'apply_filters', {
                    location: 'build-a-box',
                    label: 'Category',
                    value: value
                });
            }
        },
        currentCategories(){
            return this.categoriesArray.filters;
        },
        plusIcon(){
            return this.collapsed == true ? '+' : '-';
        }
    },
    methods: {
        collapse(){
            this.collapsed = !this.collapsed;
        },
        setSelectedCategories(value){
            this.$store.commit('setSelectedCategories', value )
        },
    },
    mounted(){
        this.$smoothReflow();
    },
}
</script>

<style scoped>
.categories-filter{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    box-shadow: inset 0px -1px 0px #E6E8EC;
}

.icon{
    cursor: pointer;
}

.title-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 2% 0%;
}
.title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
}

.checkbox-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0% 0% 3% 0%;
    width: 100%;
    overflow: hidden;
}

.occasion-title{
    color: #0F0C38;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.2vw;
    line-height: 1.43;
}

.checkbox-button{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 1% 0%;
}

.checkbox-button p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2vw;
    line-height: 1.43;
    color: #0F0C38;
}

.checkbox-button .red{
    color: red;
}

@media screen and (max-width: 767px){
    .title{
        font-size: 1.2rem;
    }

    .icon{
        font-size: 2rem;
    }

    .title-container{
        font-size: 1rem;
    }

    .occasion-title{
        font-size: 1rem;
    }

    .checkbox-button p{
        font-size: 1rem;
    }
}
</style>